// removed by extract-text-webpack-plugin
module.exports = {"Gallery":"Gallery__Gallery__piBUq","MainImage":"Gallery__MainImage__2COhY","navLeft":"Gallery__navLeft__GNPoK","navRight":"Gallery__navRight__3SLw9","prevPhoto":"Gallery__prevPhoto__2_FHJ","nextPhoto":"Gallery__nextPhoto__38ldG","Spinner":"Gallery__Spinner__13_TT","Error":"Gallery__Error__12SLf","showSidebar":"Gallery__showSidebar__1IpRR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Gallery/Gallery.css
// module id = 75
// module chunks = 0